<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import {vanBanDenModel} from "@/models/vanBanDenModel";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import vue2Dropzone from "vue2-dropzone";
import {vanBanDiModel} from "@/models/vanBanDiModel";

export default {
  page: {
    title: "Văn bản đã gửi",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    PageHeader,
    Multiselect,
    DatePicker,
    vueDropzone: vue2Dropzone,
    Switches
  },
  data() {
    return {
      title: "Soạn văn bản",
      data: [],
      showModal: false,
      submitted: false,
      model: vanBanDiModel.baseJson(),
      optionsLoaiVanBan: [],
      optionsDonVi: [],
      optionsDonViTree: [],
      optionsLinhVuc: [],
      optionsUser: [],
      optionsTrangThaiAll: [],
      optionsHinhThucNhan: [],
      optionsMucDo: [],
      optionsTrangThai: [],
      optionsCapVanBan: [],
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      urlView: `${process.env.VUE_APP_API_URL}files/view/`,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 1,
        maxFilesize: 100,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".pdf",
        dropzoneClassName: "dropzonevue-box"
      },
      dropzoneOptionsPhuLuc: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 30,
        maxFilesize: 100,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".pdf, .doc, .docx, .xlsx, .xlsx, .zip, .rar",
        dropzoneClassName: "dropzonevue-box"
      },
      showButtonSave: false,
      isShow: false,
      code: null,
      canBoSoan: []
    };
  },
  validations: {
    model: {
      loaiVanBan: {required},
      trangThai: {required},
      trichYeu: {required},
    },
  },
  async created() {
    this.init();
    if (this.$route.params.id) {
      this.handleDetail();
    } else {
      this.handleCreate();
    }

  },
  watch: {
  },
  methods: {
    init(){
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      Promise.all([ this.getLoaiVanBan(),  this.getDonVi(),  this.getUser(), this.getLinhVuc(), this.getHinhThuc(),
        this.getMucDo(),
        this.getDonViTree(), this.getAllTrangThai(), this.getCapVanBan()
      ]).then((values) => {
        loader.hide()
      });
    },
    asyncGetCanBoSoan(selectedOption, id){
      this.canBoSoan = this.optionsUser.filter(x => x.donVi && x.donVi.id == selectedOption.id);
    },
    async handleDetail() {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("vanBanDiStore/getById", this.$route.params.id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.model = res.data;
          this.showModal = true;
          this.getTrangThai(this.model.trangThai)

          loader.hide();
          this.showButtonSave = false;
        }
      });
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.model.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          //Update model
          await this.$store.dispatch("vanBanDiStore/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = vanBanDenModel.baseJson()
              this.isShow = true;
              this.code = res;
            }
          })
        } else {
          //Create modelhandleSubmit
          this.model.version = 1;
          await this.$store.dispatch("vanBanDiStore/create", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = vanBanDiModel.baseJson();
              this.isShow = true;
              this.code = res;
            }
            // this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
            //this.$router.push('/van-ban-di')
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleCreate() {
      await this.$store.dispatch("vanBanDiStore/getVaCapSo").then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = res.data;
          this.showButtonSave = true;

          const localStoreUser = localStorage.getItem('auth-user');
          const userAuth = JSON.parse(localStoreUser);

          if(userAuth && userAuth.user){
            let user = userAuth.user;
            let donVi = user.donVi;
            let findDonVi = this.optionsDonVi.find(x => x.id == donVi.id);
            this.model.donViSoan = findDonVi;
          }

          if(userAuth && userAuth.user){
            let find = this.canBoSoan.find(x => x.id == userAuth.userId);
            this.model.canBoSoan = find;
          }
        }
      });
      this.getTrangThai(null);
    },
    handleDeleteFile(index) {
      if (this.model) {
        if (this.model.file) {
          this.model.file.splice(index, 1);
        }

      }
    },
    handleDeleteFilePhuLuc(index) {
      if (this.model) {
        if (this.model.phuLucDinhKem) {
          this.model.phuLucDinhKem.splice(index, 1);
        }

      }
    },
    async getLoaiVanBan() {
      await this.$store.dispatch("loaiVanBanStore/getAll").then((res) => {
        if (res.resultCode === "SUCCESS") {
          this.optionsLoaiVanBan = res.data;
        } else {
          this.optionsLoaiVanBan = [];
        }
      });
    },
    async getTrangThai(currentTrangThai) {
      try {
        await this.$store.dispatch("trangThaiStore/getNextTrangThai", {
          loaiTrangThai: "VBDi",
          currentTrangThai: currentTrangThai
        }).then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data;
            this.loading = false
            this.optionsTrangThai = items;
            if(this.model.trangThai == null){
              var newItem = this.optionsTrangThai.find(x => x.code == "ktvb");
              this.model.trangThai = newItem;
            }
            return items || []
          }
          return [];
        })
      } finally {
        this.loading = false
      }
    },
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonVi = items;
            const localStoreUser = localStorage.getItem('auth-user');
            const userAuth = JSON.parse(localStoreUser);

            if(userAuth && userAuth.user){
              let user = userAuth.user;
              let donVi = user.donVi;
              let findDonVi = this.optionsDonVi.find(x => x.id == donVi.id);
              this.model.donViSoan = findDonVi;
            }
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getCapVanBan() {
      try {
        await this.$store.dispatch("capVanBanStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsCapVanBan = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getDonViTree() {
      try {
        await this.$store.dispatch("donViStore/getTree").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonViTree = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
            this.canBoSoan = items;


          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getAllTrangThai() {
      await this.$store.dispatch("trangThaiStore/getTrangThai").then(resp => {
        if (resp.resultCode == "SUCCESS") {
          let items = resp.data

          this.optionsTrangThaiAll = items;
        }
        return [];
      });
    },
    async getLinhVuc() {
      try {
        await this.$store.dispatch("dmLinhVucStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsLinhVuc = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getHinhThuc() {
      try {
        let promise = this.$store.dispatch("hinhThucGuiStore/get")
        return promise.then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsHinhThucNhan = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getMucDo() {
      await this.$store.dispatch("enumStore/getMucDo").then((res) => {
        if (res.resultCode === "SUCCESS") {
          this.optionsMucDo = res.data;
        } else {
          this.optionsMucDo = [];
        }
      });
    },
    removeThisFilePhuLuc(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadPhuLucDinhKem.filter(x => {
          return x.fileId != idFile;
        })
        this.model.uploadPhuLucDinhKem = resultData;
      }
    },
    addThisFilePhuLuc(file, response) {
      if (this.model) {
        if (this.model.uploadPhuLucDinhKem == null || this.model.uploadPhuLucDinhKem.length <= 0) {
          this.model.uploadPhuLucDinhKem = [];
        }
        let fileSuccess = response.data;
        this.model.uploadPhuLucDinhKem.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext})
      }
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadFiles.filter(x => {
          return x.fileId != idFile;
        })
        this.model.uploadFiles = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.model) {
        if (this.model.uploadFiles == null || this.model.uploadFiles.length <= 0) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.uploadFiles.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext})
      }
    },
    handleHideModal() {
      this.isShow = false;
      this.$router.push('/xu-ly-van-ban-di')
    },
    handleShowFile(id) {
      let route = this.$router.resolve({path: '/xem-tep-tin/' + id});
      window.open(route.href, '_blank');
    },
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-12 col-xl-6">
                <PageHeader :title="title"/>
              </div>
              <div class="col-12 col-xl-6">
                <div class="text-end">
                  <b-button type="submit" variant="primary" class="ms-1" style="width: 80px"
                            size="sm"
                            @click="handleSubmit"
                  >
                    Lưu
                  </b-button>
                </div>
              </div>

            </div>

            <form @submit.prevent="handleSubmit"
                  ref="formContainer">
              <div class="row">
                <div class="col-md-7">
                  <div class="row">
                    <!--                            Loại văn bản-->
                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Loại văn bản </label> <span
                          class="text-danger">(*)</span>
                        <multiselect
                            v-model="model.loaiVanBan"
                            :options="optionsLoaiVanBan"
                            track-by="id"
                            label="ten"
                            placeholder="Chọn loại văn bản"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                            :class="{'is-invalid': submitted && $v.model.loaiVanBan.$error,}"
                        ></multiselect>
                        <div
                            v-if="submitted && !$v.model.loaiVanBan.required"
                            class="invalid-feedback"
                        >
                          Loại văn bản không được để trống.
                        </div>
                      </div>
                    </div>
                    <!--                              Số lưu -->
                    <div class="col-lg-6 col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Số lưu CV</label>
                        <input
                            id="validationCustom01"
                            v-model="model.soLuuCV"
                            type="text"
                            class="form-control"
                            placeholder=""
                            readonly
                        />
                      </div>
                    </div>
                    <!--                            Số CV đi -->
                    <div class="col-lg-4 col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Số CV đi <span style="color: red"> Lưu ý: {số}/{ký hiệu}</span></label>
                        <input
                            id="validationSoVBDen"
                            v-model="model.soVBDi"
                            type="text"
                            class="form-control"
                            placeholder=""

                        />
                      </div>
                    </div>
                    <!--                            Ngày nhập -->
                    <div class="col-lg-4 col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Ngày nhập</label>
                        <!--                                <date-picker-->
                        <!--                                    v-model="model.ngayNhap"-->
                        <!--                                    format="DD/MM/YYYY"-->
                        <!--                                    :first-day-of-week="1"-->
                        <!--                                    lang="en"-->
                        <!--                                    placeholder="Chọn ngày nhập"-->
                        <!--                                ></date-picker>-->
                        <date-picker v-model="model.ngayNhap"
                                     format="DD/MM/YYYY"
                                     value-type="format"
                        >
                          <div slot="input">
                            <input v-model="model.ngayNhap"
                                   v-mask="'##/##/####'" type="text" class="form-control"
                                   placeholder="Nhập ngày nhập"/>
                          </div>
                        </date-picker>
                      </div>
                    </div>
                    <!--                              Trả lời Cv số -->
                    <div class="col-lg-4 col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Trả lời CV số</label>
                        <input
                            id="validationCustom01"
                            v-model="model.traLoiCVSo"
                            type="text"
                            class="form-control"
                            placeholder=""
                        />
                      </div>
                    </div>
                    <!--                            Ngày trả lời -->
                    <div class="col-lg-4 col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Ngày trả lời</label>
                        <date-picker v-model="model.ngayTraLoi"
                                     format="DD/MM/YYYY"
                                     value-type="format"
                        >
                          <div slot="input">
                            <input v-model="model.ngayTraLoi"
                                   v-mask="'##/##/####'" type="text" class="form-control"
                                   placeholder="Nhập ngày trả lời"/>
                          </div>
                        </date-picker>
                      </div>
                    </div>
                    <!--                            Số VB đến -->
                    <div class="col-lg-4 col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Số bản</label>
                        <input
                            id="validationSoVBDen"
                            v-model="model.soBan"
                            type="number"
                            class="form-control"
                            placeholder=""

                        />
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Người ký</label>
                        <multiselect
                            v-model="model.nguoiKy"
                            :options="optionsUser"
                            track-by="id"
                            label="fullName"
                            placeholder="Chọn cán bộ soạn"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.fullName }}</strong>

                            <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                          </template>
                          <template slot="option" slot-scope="{ option }">
                            <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                              <span v-if="option.donVi" class="option__small"
                                    style="color:green">{{ option.donVi.ten }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <!--                            Ngày Ký-->
                    <div class="col-md-6 col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Ngày ký</label>
                        <date-picker v-model="model.ngayKy"
                                     format="DD/MM/YYYY"
                                     value-type="format"
                        >
                          <div slot="input">
                            <input v-model="model.ngayKy"
                                   v-mask="'##/##/####'" type="text" class="form-control"
                                   placeholder="Nhập ngày ký"/>
                          </div>
                        </date-picker>
                      </div>
                    </div>
                    <!--                            Trích yếu -->
                    <div class="col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Trích yếu</label>
                        <span class="text-danger">(*)</span>
                        <textarea class="form-control" v-model="model.trichYeu" rows="4"></textarea>
                        <div
                            v-if="submitted && !$v.model.trichYeu.required"
                            class="invalid-feedback"
                        >
                            Trích yếu không được để trống.
                        </div>
                      </div>
                    </div>
                    <div v-if="model.filePDF != null  && model.filePDF.length > 0" class="col-md-12">
                      <label for="">Danh sách đã ký (Nhấn vào để tải xuống)</label>
                      <template>
                        <div v-for="(file, index) in model.filePDF" :key="index">
                          <a
                              :href="`${apiUrl}files/view/${file.fileId}`"
                              class=" fw-medium"
                          ><i
                              :class="`mdi font-size-16 align-middle me-2`"
                          ></i>
                            {{ index + 1 }}: {{ file.fileName }}</a
                          >
                        </div>
                      </template>

                    </div>
                    <div v-if="model.id" class="col-md-12">
                      <label for=""> Văn bản trình ký</label>
                      <template v-if="model.file == null || (model.file != null &&model.file.length <= 0)">
                        <div>
                          <b-alert variant="danger" class="mb-0" show>
                            <strong><i class="mdi mdi-close-circle-outline"></i></strong> Không có tệp tin văn bản.
                          </b-alert>
                        </div>
                      </template>
                      <template v-else>
                        <div class="col-md-12"
                             style="display: flex; flex-direction: column; padding: 0px"
                        >
                          <div
                          >
                            <div
                                v-for="(value, index) in model.file" :key="index"
                                style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                            >
                              <a
                                  :href="`${apiUrl}files/view/${value.fileId}`"
                                  class=" fw-medium"
                              ><i
                                  class="fas fa-cloud-download-alt"
                              ></i>
                                [Tải về]</a
                              >

                              <a
                                  v-if="value.ext == '.pdf'"
                                  target="_blank"
                                  class="fw-medium text-danger"
                                  @click="handleShowFile(value.fileId)"
                                  style="cursor: pointer"
                              >
                                [Xem]</a>
                              <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>
                              <button
                                  type="button"
                                  size="sm"
                                  class="btn btn-outline btn-sm"
                                  data-toggle="tooltip" data-placement="bottom" title="Xóa"
                                  v-on:click="handleDeleteFile(index)">
                                <i class="fas fa-trash-alt text-danger me-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div v-if="model.uploadFiles" class="col-md-12">

                      <template v-if="model.uploadFiles == null || (model.uploadFiles != null && model.uploadFiles.length <= 0)">
                        <div>
                          <b-alert variant="danger" class="mb-0" show>
                            <strong><i class="mdi mdi-close-circle-outline"></i></strong> Không có tệp tin văn bản.
                          </b-alert>
                        </div>
                      </template>
                      <template v-else>
                        <label for=""> Xem trước tệp tin</label>
                        <div class="col-md-12"
                             style="display: flex; flex-direction: column; padding: 0px"
                        >
                          <div
                          >
                            <div
                                v-for="(value, index) in model.uploadFiles" :key="index"
                                style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                            >
                              <a
                                  :href="`${apiUrl}files/view/${value.fileId}`"
                                  class=" fw-medium"
                              ><i
                                  class="fas fa-cloud-download-alt"
                              ></i>
                                [Tải về]</a
                              >

                              <a
                                  v-if="value.ext == '.pdf'"
                                  target="_blank"
                                  class="fw-medium text-danger"
                                  @click="handleShowFile(value.fileId)"
                                  style="cursor: pointer"
                              >
                                [Xem]</a>
                              <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>

                            </div>
                          </div>
                        </div>
                      </template>
                    </div>

                    <!--                            file đính kèm-->
                    <div class="col-md-12">
                      <label for=""> <i class="mdi mdi mdi-tag mdi-rotate-135 me-1"></i> Nội dung văn bản trình ký  <span class="text-danger"> (*.pdf)</span></label>

                      <vue-dropzone
                          id="dropzone"
                          ref="myVueDropzone"
                          :use-custom-slot="true"
                          :options="dropzoneOptions"
                          class="dropzonevue-box"
                          v-on:vdropzone-removed-file="removeThisFile"
                          v-on:vdropzone-success="addThisFile"

                      >
                        <div class="">
                          <i
                              class="text-muted mdi mdi-cloud-upload"
                          ></i>
                          <h4 class="font-size-18">
                            Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                          </h4>
                        </div>
                      </vue-dropzone>
                    </div>
                    <div style="margin-top: 20px"> </div>
                    <div class="col-md-12 pb-2">
                      <div class=" d-flex align-items-center">
                        <switches v-model="model.isShowPhuLuc" color="primary" class="ml-1 me-2"></switches>
                        <label for="" v-if="model.isShowPhuLuc"> Hiển thị hồ sơ kèm công văn khi ban hành ra mục thông báo</label>
                        <label for="" v-else>Hồ sơ này sẽ không gửi kèm công văn khi ban hành</label>
                      </div>
                    </div>
                    <div v-if="model.id" class="col-md-12">
                      <template v-if="model.phuLucDinhKem == null || (model.phuLucDinhKem != null &&model.phuLucDinhKem.length <= 0)">
                        <div>
                          <b-alert variant="danger" class="mb-0" show>
                            <strong><i class="mdi mdi-close-circle-outline"></i></strong> Không có tệp tin văn bản.
                          </b-alert>
                        </div>
                      </template>
                      <template v-else>
                        <div class="col-md-12"
                             style="display: flex; flex-direction: column; padding: 0px"
                        >
                          <div
                          >
                            <div
                                v-for="(value, index) in model.phuLucDinhKem" :key="index"
                                style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                            >
                              <a
                                  :href="`${apiUrl}files/view/${value.fileId}`"
                                  class=" fw-medium"
                              ><i
                                  class="fas fa-cloud-download-alt"
                              ></i>
                                [Tải về]</a
                              >

                              <a
                                  v-if="value.ext == '.pdf'"
                                  target="_blank"
                                  class="fw-medium text-danger"
                                  @click="handleShowFile(value.fileId)"
                                  style="cursor: pointer"
                              >
                                [Xem]</a>
                              <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>
                              <button
                                  type="button"
                                  size="sm"
                                  class="btn btn-outline btn-sm"
                                  data-toggle="tooltip" data-placement="bottom" title="Xóa"
                                  v-on:click="handleDeleteFilePhuLuc(index)">
                                <i class="fas fa-trash-alt text-danger me-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div v-if="model.uploadPhuLucDinhKem" class="col-md-12">

                      <template v-if="model.uploadPhuLucDinhKem == null || (model.uploadPhuLucDinhKem != null && model.uploadPhuLucDinhKem.length <= 0)">
                        <div>
<!--                          <b-alert variant="danger" class="mb-0" show>-->
<!--                            <strong><i class="mdi mdi-close-circle-outline"></i></strong> Không có tệp tin văn bản.-->
<!--                          </b-alert>-->
                        </div>
                      </template>
                      <template v-else>
                        <label for=""> Xem trước tệp tin</label>
                        <div class="col-md-12"
                             style="display: flex; flex-direction: column; padding: 0px"
                        >
                          <div
                          >
                            <div
                                v-for="(value, index) in model.uploadPhuLucDinhKem" :key="index"
                                style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                            >
                              <a
                                  :href="`${apiUrl}files/view/${value.fileId}`"
                                  class=" fw-medium"
                              ><i
                                  class="fas fa-cloud-download-alt"
                              ></i>
                                [Tải về]</a
                              >

                              <a
                                  v-if="value.ext == '.pdf'"
                                  target="_blank"
                                  class="fw-medium text-danger"
                                  @click="handleShowFile(value.fileId)"
                                  style="cursor: pointer"
                              >
                                [Xem]</a>
                              <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>

                            </div>
                          </div>
                        </div>
                      </template>
                    </div>



                    <!-- Phụ lục đính kèm -->
                    <div class="col-md-12">
                      <label for=""> <i class="mdi mdi mdi-tag mdi-rotate-135 me-1"></i> Hồ sơ kèm theo văn bản trình ký <span class="text-danger"> (*.pdf, *.doc, *.docx, *.xls,  *.xlsx, *.rar, *.zip)</span></label>
                      <vue-dropzone
                          id="dropzone"
                          ref="myVueDropzone"
                          :use-custom-slot="true"
                          :options="dropzoneOptionsPhuLuc"
                          class="dropzonevue-box"
                          v-on:vdropzone-removed-file="removeThisFilePhuLuc"
                          v-on:vdropzone-success="addThisFilePhuLuc"
                      >
                        <div class="">
                          <i
                              class="text-muted mdi mdi-cloud-upload"
                          ></i>
                          <h4 class="font-size-18">
                            Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                          </h4>
                        </div>
                      </vue-dropzone>
                    </div>
                  </div>

                </div>

                <div class="col-md-5">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Đơn vị soạn</label>
                        <multiselect
                            @select="asyncGetCanBoSoan"
                            v-model="model.donViSoan"
                            :options="optionsDonVi"
                            track-by="id"
                            label="ten"
                            placeholder="Chọn đơn vị soạn"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        ></multiselect>

                      </div>
                    </div>
                    <!--                            Cơ quan gửi-->
                    <div class="col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Cán bộ soạn</label>
                        <multiselect
                            v-model="model.canBoSoan"
                            :options="canBoSoan"
                            track-by="id"
                            label="fullName"
                            placeholder="Chọn cán bộ soạn"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.fullName }}</strong>

                            <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                          </template>
                          <template slot="option" slot-scope="{ option }">
                            <div class="option__desc">
                            <span class="option__title">
                              <strong>{{ option.fullName }}&nbsp;</strong>
                            </span>
                              <span v-if="option.donVi" class="option__small"
                                    style="color:green">{{ option.donVi.ten }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <!--                            Hình thức nhận -->
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Hình thức nhận</label>
                        <multiselect
                            v-model="model.hinhThucGui"
                            :options="optionsHinhThucNhan"
                            track-by="id"
                            label="ten"
                            placeholder="Chọn hình thức nhận"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        ></multiselect>
                      </div>
                    </div>
                    <!--                            Lĩnh vực-->
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Lĩnh vực</label>
                        <multiselect
                            v-model="model.linhVuc"
                            :options="optionsLinhVuc"
                            track-by="id"
                            label="ten"
                            placeholder="Chọn lĩnh vực"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        ></multiselect>
                      </div>
                    </div>
                    <!--                            Mức độ tính chất-->
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Mức độ tính chất</label>
                        <multiselect
                            v-model="model.mucDoTinhChat"
                            :options="optionsMucDo"
                            track-by="id"
                            label="name"
                            placeholder="Chọn mức độ tính chất"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        ></multiselect>
                      </div>
                    </div>
                    <!--                            Mức độ bảo mật-->
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Mức độ bảo mật</label>
                        <multiselect
                            v-model="model.mucDoBaoMat"
                            :options="optionsMucDo"
                            track-by="id"
                            label="name"
                            placeholder="Chọn mức độ bảo mật"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                        ></multiselect>
                      </div>
                    </div>
                    <!--                            Hồ sơ đơn vị-->
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Hồ sơ đơn vị</label>
                        <input
                            v-model="model.hoSoDonVi"
                            type="text"
                            class="form-control"
                            placeholder=""
                        />
                      </div>
                    </div>
                    <!--                            Nơi lưu trữ-->
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Nơi lưu trữ</label>
                        <input
                            v-model="model.noiLuuTru"
                            type="text"
                            class="form-control"
                            placeholder="Nhập nơi lưu trữ"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <b-modal
                v-model="isShow"
                title="Thông tin lĩnh vực"
                title-class="text-black font-18"
                body-class="p-3"
                hide-footer
                hide-header
                centered
                no-close-on-backdrop
                size="md"
                style="padding: 0px"
            >
              <Transition name="fade" mode="out-in">
                <div class="row justify-content-center">
                  <div class="col-md-12"
                       style="display: flex; justify-content: center; align-items: center; padding: 40px 40px; flex-direction: column;">
                    <!--                <i class='bx bx-check-circle h1 text-success' style="font-size: 100px; margin-bottom: 40px"></i>-->
                    <div class="success-checkmark">
                      <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                      </div>
                    </div>
                    <h1 v-if="code" class="fw-bold fs-3 text-dark text-uppercase">{{ code.resultString }}</h1>
                    <button type="button" v-on:click="handleHideModal" class="btn btn-modal text-uppercase"
                            style="width: 200px; margin-top: 20px; border-radius: 30px">Đồng ý
                    </button>
                  </div>
                </div>
              </Transition>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.title-capso {
  font-weight: bold;
  color: #00568C;

}

.content-capso {
  color: #00568C;
  padding-left: 10px;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}
</style>
<style lang="scss">
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;

  .check-icon {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #4CAF50;

    &::before {
      top: 3px;
      left: -2px;
      width: 30px;
      transform-origin: 100% 50%;
      border-radius: 100px 0 0 100px;
    }

    &::after {
      top: 0;
      left: 30px;
      width: 60px;
      transform-origin: 0 50%;
      border-radius: 0 100px 100px 0;
      animation: rotate-circle 4.25s ease-in;
    }

    &::before, &::after {
      content: '';
      height: 100px;
      position: absolute;
      background: #FFFFFF;
      transform: rotate(-45deg);
    }

    .icon-line {
      height: 5px;
      background-color: #4CAF50;
      display: block;
      border-radius: 2px;
      position: absolute;
      z-index: 10;

      &.line-tip {
        top: 46px;
        left: 14px;
        width: 25px;
        transform: rotate(45deg);
        animation: icon-line-tip 0.75s;
      }

      &.line-long {
        top: 38px;
        right: 8px;
        width: 47px;
        transform: rotate(-45deg);
        animation: icon-line-long 0.75s;
      }
    }

    .icon-circle {
      top: -4px;
      left: -4px;
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      border: 4px solid rgba(76, 175, 80, .5);
    }

    .icon-fix {
      top: 8px;
      width: 5px;
      left: 26px;
      z-index: 1;
      height: 85px;
      position: absolute;
      transform: rotate(-45deg);
      background-color: #FFFFFF;
    }
  }
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

.btn-modal {
  background: #00568C;
  border: none;
  color: #fff;
}

.btn-modal:hover {
  background: #00568C;
  border: none;
  color: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}

</style>
